import { MenuItem } from "@mui/material";
import DropDownButton from "components/DropDownButton";
import React from "react";
import typeExports from "entity/LaudoVisita/exports/tipos";

export default function DropDownExports({ laudos }) {
    return (
        <div>
            <DropDownButton color="primary" label="Export">
                {typeExports.map((ExportC, index) => {
                    return <MenuItem key={index} onClick={() => ExportC.exportFile(laudos)}>{ExportC.nome}</MenuItem>;
                })}
            </DropDownButton>
        </div>
    );
}
